import { Monitor, MapPin, Wifi, Building } from "lucide-react";

export const ClosingOptions = () => {
  const options = [
    {
      icon: Monitor,
      title: "Remote Online Notarization (RON)",
      description: "Complete your closing from anywhere with secure video conferencing and digital signatures. Perfect for out-of-state buyers or busy schedules.",
      features: ["Video-verified identity", "Digital notarization", "Instant document delivery"],
    },
    {
      icon: MapPin,
      title: "On-Site Property Closing",
      description: "We come to you at the property, your office, or any convenient location. Ideal for celebrating a new purchase at the home itself.",
      features: ["Mobile notary service", "Flexible scheduling", "Personal service"],
    },
    {
      icon: Wifi,
      title: "Fully Remote Closing",
      description: "Sign documents electronically from the comfort of your home or office. We handle all the coordination and document delivery.",
      features: ["E-signature enabled", "Secure document portal", "Real-time support"],
    },
    {
      icon: Building,
      title: "Traditional In-Office",
      description: "Visit one of our offices for a classic closing experience with our team by your side to answer any questions.",
      features: ["PA, NJ, NY, FL locations", "Conference rooms", "Full team support"],
    },
  ];

  return (
    <section id="closing-options" className="py-24 lg:py-32 bg-white" data-testid="closing-options-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-2xl mb-16">
          <p className="text-xs font-bold uppercase tracking-widest text-[#B45309] mb-4">Closing Options</p>
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-[#0F172A] tracking-tight mb-6">
            Close on Your Terms
          </h2>
          <p className="text-lg text-[#64748B] leading-relaxed">
            Every transaction is different. That's why we offer flexible closing options 
            designed to fit your schedule, your location, and your preferences.
          </p>
        </div>

        {/* Options Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {options.map((option, index) => (
            <div
              key={index}
              className="group p-8 bg-[#FAFAF9] border border-[#E7E5E4] hover:border-[#0F172A]/20 card-shadow"
              data-testid={`closing-option-${index}`}
            >
              <div className="flex items-start gap-6">
                <div className="w-14 h-14 flex items-center justify-center bg-[#0F172A] text-white flex-shrink-0 group-hover:bg-[#B45309] btn-transition">
                  <option.icon className="w-6 h-6" strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="font-serif text-xl font-medium text-[#0F172A] mb-3">
                    {option.title}
                  </h3>
                  <p className="text-[#64748B] leading-relaxed text-sm mb-4">
                    {option.description}
                  </p>
                  <div className="flex gap-2">
                    {option.features.map((feature, fIndex) => (
                      <span
                        key={fIndex}
                        className="text-[11px] font-medium text-[#0F172A] bg-white px-2 py-1 border border-[#E7E5E4] whitespace-nowrap"
                      >
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
